// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as JoinRouteImport } from './routes/join'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DiyIndexRouteImport } from './routes/diy/index'
import { Route as DiyCreateRouteImport } from './routes/diy/create'
import { Route as DiySlugRouteImport } from './routes/diy/$slug'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedQueueRouteImport } from './routes/_authed/queue'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedTasksIndexRouteImport } from './routes/_authed/tasks/index'
import { Route as AuthedRewardsIndexRouteImport } from './routes/_authed/rewards/index'
import { Route as AuthedProjectsIndexRouteImport } from './routes/_authed/projects/index'
import { Route as AuthedPlansIndexRouteImport } from './routes/_authed/plans/index'
import { Route as AuthedAssetsIndexRouteImport } from './routes/_authed/assets/index'
import { Route as AuthedTasksTaskIdRouteImport } from './routes/_authed/tasks/$taskId'
import { Route as AuthedRewardsNewRouteImport } from './routes/_authed/rewards/new'
import { Route as AuthedProjectsProjectIdRouteImport } from './routes/_authed/projects/$projectId'
import { Route as AuthedPlansNewRouteImport } from './routes/_authed/plans/new'
import { Route as AuthedPlansPlanIdRouteImport } from './routes/_authed/plans/$planId'
import { Route as AuthedAssetsNewRouteImport } from './routes/_authed/assets/new'
import { Route as AuthedAssetsIdRouteImport } from './routes/_authed/assets/$id'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as AuthedSettingsNotificationsRouteImport } from './routes/_authed/settings/notifications'
import { Route as AuthedSettingsGroupRouteImport } from './routes/_authed/settings/group'
import { Route as AuthedSettingsCookiesRouteImport } from './routes/_authed/settings/cookies'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedTasksNewIndexRouteImport } from './routes/_authed/tasks/new/index'
import { Route as AuthedProjectsNewIndexRouteImport } from './routes/_authed/projects/new/index'
import { Route as AuthedPlansPlanIdEditRouteImport } from './routes/_authed/plans/$planId.edit'
import { Route as AuthedAssetsNewIndexRouteImport } from './routes/_authed/assets/new/index'
import { Route as AuthedAssetsNewConfigureRouteImport } from './routes/_authed/assets/new/configure'
import { Route as AuthedAssetsNewCompleteRouteImport } from './routes/_authed/assets/new/complete'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignOutRoute = SignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DiyIndexRoute = DiyIndexRouteImport.update({
            id: '/diy/',path: '/diy/',getParentRoute: () => rootRouteImport
          })
const DiyCreateRoute = DiyCreateRouteImport.update({
            id: '/diy/create',path: '/diy/create',getParentRoute: () => rootRouteImport
          })
const DiySlugRoute = DiySlugRouteImport.update({
            id: '/diy/$slug',path: '/diy/$slug',getParentRoute: () => rootRouteImport
          })
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedRoute
          })
const AuthedQueueRoute = AuthedQueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => AuthedRoute
          })
const AuthedProfileRoute = AuthedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthedRoute
          })
const AuthedAdminRoute = AuthedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedRoute
          })
const AuthedTasksIndexRoute = AuthedTasksIndexRouteImport.update({
            id: '/tasks/',path: '/tasks/',getParentRoute: () => AuthedRoute
          })
const AuthedRewardsIndexRoute = AuthedRewardsIndexRouteImport.update({
            id: '/rewards/',path: '/rewards/',getParentRoute: () => AuthedRoute
          })
const AuthedProjectsIndexRoute = AuthedProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AuthedRoute
          })
const AuthedPlansIndexRoute = AuthedPlansIndexRouteImport.update({
            id: '/plans/',path: '/plans/',getParentRoute: () => AuthedRoute
          })
const AuthedAssetsIndexRoute = AuthedAssetsIndexRouteImport.update({
            id: '/assets/',path: '/assets/',getParentRoute: () => AuthedRoute
          })
const AuthedTasksTaskIdRoute = AuthedTasksTaskIdRouteImport.update({
            id: '/tasks/$taskId',path: '/tasks/$taskId',getParentRoute: () => AuthedRoute
          })
const AuthedRewardsNewRoute = AuthedRewardsNewRouteImport.update({
            id: '/rewards/new',path: '/rewards/new',getParentRoute: () => AuthedRoute
          })
const AuthedProjectsProjectIdRoute = AuthedProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AuthedRoute
          })
const AuthedPlansNewRoute = AuthedPlansNewRouteImport.update({
            id: '/plans/new',path: '/plans/new',getParentRoute: () => AuthedRoute
          })
const AuthedPlansPlanIdRoute = AuthedPlansPlanIdRouteImport.update({
            id: '/plans/$planId',path: '/plans/$planId',getParentRoute: () => AuthedRoute
          })
const AuthedAssetsNewRoute = AuthedAssetsNewRouteImport.update({
            id: '/assets/new',path: '/assets/new',getParentRoute: () => AuthedRoute
          })
const AuthedAssetsIdRoute = AuthedAssetsIdRouteImport.update({
            id: '/assets/$id',path: '/assets/$id',getParentRoute: () => AuthedRoute
          })
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedSettingsRoute
          })
const AuthedSettingsNotificationsRoute = AuthedSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthedSettingsRoute
          })
const AuthedSettingsGroupRoute = AuthedSettingsGroupRouteImport.update({
            id: '/group',path: '/group',getParentRoute: () => AuthedSettingsRoute
          })
const AuthedSettingsCookiesRoute = AuthedSettingsCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => AuthedSettingsRoute
          })
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAdminRoute
          })
const AuthedTasksNewIndexRoute = AuthedTasksNewIndexRouteImport.update({
            id: '/tasks/new/',path: '/tasks/new/',getParentRoute: () => AuthedRoute
          })
const AuthedProjectsNewIndexRoute = AuthedProjectsNewIndexRouteImport.update({
            id: '/projects/new/',path: '/projects/new/',getParentRoute: () => AuthedRoute
          })
const AuthedPlansPlanIdEditRoute = AuthedPlansPlanIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AuthedPlansPlanIdRoute
          })
const AuthedAssetsNewIndexRoute = AuthedAssetsNewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAssetsNewRoute
          })
const AuthedAssetsNewConfigureRoute = AuthedAssetsNewConfigureRouteImport.update({
            id: '/configure',path: '/configure',getParentRoute: () => AuthedAssetsNewRoute
          })
const AuthedAssetsNewCompleteRoute = AuthedAssetsNewCompleteRouteImport.update({
            id: '/complete',path: '/complete',getParentRoute: () => AuthedAssetsNewRoute
          })





const AuthedAdminRouteChildren = {
  AuthedAdminIndexRoute: AuthedAdminIndexRoute
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(AuthedAdminRouteChildren)




const AuthedSettingsRouteChildren = {
  AuthedSettingsCookiesRoute: AuthedSettingsCookiesRoute,AuthedSettingsGroupRoute: AuthedSettingsGroupRoute,AuthedSettingsNotificationsRoute: AuthedSettingsNotificationsRoute,AuthedSettingsIndexRoute: AuthedSettingsIndexRoute
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(AuthedSettingsRouteChildren)




const AuthedAssetsNewRouteChildren = {
  AuthedAssetsNewCompleteRoute: AuthedAssetsNewCompleteRoute,AuthedAssetsNewConfigureRoute: AuthedAssetsNewConfigureRoute,AuthedAssetsNewIndexRoute: AuthedAssetsNewIndexRoute
}

const AuthedAssetsNewRouteWithChildren = AuthedAssetsNewRoute._addFileChildren(AuthedAssetsNewRouteChildren)




const AuthedPlansPlanIdRouteChildren = {
  AuthedPlansPlanIdEditRoute: AuthedPlansPlanIdEditRoute
}

const AuthedPlansPlanIdRouteWithChildren = AuthedPlansPlanIdRoute._addFileChildren(AuthedPlansPlanIdRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,AuthedDashboardRoute: AuthedDashboardRoute,AuthedProfileRoute: AuthedProfileRoute,AuthedQueueRoute: AuthedQueueRoute,AuthedSettingsRoute: AuthedSettingsRouteWithChildren,AuthedAssetsIdRoute: AuthedAssetsIdRoute,AuthedAssetsNewRoute: AuthedAssetsNewRouteWithChildren,AuthedPlansPlanIdRoute: AuthedPlansPlanIdRouteWithChildren,AuthedPlansNewRoute: AuthedPlansNewRoute,AuthedProjectsProjectIdRoute: AuthedProjectsProjectIdRoute,AuthedRewardsNewRoute: AuthedRewardsNewRoute,AuthedTasksTaskIdRoute: AuthedTasksTaskIdRoute,AuthedAssetsIndexRoute: AuthedAssetsIndexRoute,AuthedPlansIndexRoute: AuthedPlansIndexRoute,AuthedProjectsIndexRoute: AuthedProjectsIndexRoute,AuthedRewardsIndexRoute: AuthedRewardsIndexRoute,AuthedTasksIndexRoute: AuthedTasksIndexRoute,AuthedProjectsNewIndexRoute: AuthedProjectsNewIndexRoute,AuthedTasksNewIndexRoute: AuthedTasksNewIndexRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,FeedbackRoute: FeedbackRoute,JoinRoute: JoinRoute,PrivacyRoute: PrivacyRoute,SignInRoute: SignInRoute,SignOutRoute: SignOutRoute,SignUpRoute: SignUpRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,DiySlugRoute: DiySlugRoute,DiyCreateRoute: DiyCreateRoute,DiyIndexRoute: DiyIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)